import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";
import { navLinks, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-foreground-950 text-background-200">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
                料
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{siteInfo.brand}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">{siteInfo.slogan}</p>
            <p className="mt-3 text-xs leading-relaxed text-background-400">{siteInfo.intro}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">网站导航</h4>
            <ul className="mt-4 space-y-3">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors hover:text-primary-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">话题分类</h4>
            <ul className="mt-4 space-y-3">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/materials?cat=${cat.slug}`}
                    className="text-sm text-background-300 transition-colors hover:text-primary-400"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">联系与订阅</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" />
                <a href={`mailto:${siteInfo.email}`} className="transition-colors hover:text-primary-400">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400" />
                <span>{siteInfo.serviceHours}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-accent-400" />
                <span>{siteInfo.baseCity}</span>
              </li>
            </ul>
            <p className="mt-5 text-xs leading-relaxed text-background-400">
              本站内容为公开话题的整理与观察，不构成对任何个人或机构的评价。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} {siteInfo.brand} 版权所有
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>内容均来自公开信息整理</span>
            <span className="hidden h-3 w-px bg-background-700 sm:block" />
            <span>理性围观 · 拒绝传谣</span>
          </p>
        </div>
      </div>
    </footer>
  );
}